import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

export default function SidebarMenu({ SideBar, HideWeb, toggleWebMenu }) {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
  }, []);
  return (
    <ul data-aos="fade-up">
      <li>
        <ul>
          {SideBar.map((item, index) => (
            <li
              key={index}
              className={item.submenu ? "submenu" : item.active ? "active" : ""}
            >
              {/* Normal menu item */}
              {!item.submenu && (
                <Link to={item.url}>
                  <i className={item.icon}></i>
                  <span>{item.name}</span>
                </Link>
              )}

              {/* Submenu parent */}
              {item.submenu && (
                <>
                  <button
                    className="submenu-btn submenu-dropdown"
                    onClick={() => toggleMenu(item.name)}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div>
                      <i className={item.icon}></i>
                      <span style={{ marginLeft: "10px" }}>{item.name}</span>
                    </div>
                    <span
                      className={`menu-arrow ${
                        openMenu === item.name ? "sideMenuIconRotate" : ""
                      }`}
                    ></span>
                  </button>

                  {openMenu === item.name && (
                    <ul data-aos="fade-up">
                      {item.submenu.map((sub, idx) => (
                        <li key={idx}>
                          <Link to={sub.url}>{sub.name}</Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              )}
            </li>
          ))}
          <li>
            {HideWeb == true && (
              <button
                className="submenu-btn submenu-dropdown"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
                onClick={toggleWebMenu}
              >
                <i className="ti ti-arrow-right"></i>
              </button>
            )}
          </li>
        </ul>
      </li>
    </ul>
  );
}
